import { render } from "./courseGeneral.vue?vue&type=template&id=140edc94"
import script from "./courseGeneral.vue?vue&type=script&lang=js"
export * from "./courseGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__